import { render, staticRenderFns } from "./ParamOcorrenciaFilterBar.vue?vue&type=template&id=32c793e1"
import script from "./ParamOcorrenciaFilterBar.vue?vue&type=script&lang=js"
export * from "./ParamOcorrenciaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports